import {Doughnut} from "vue-chartjs";
import updateChartMixin from "@/components/widgets/updateChartMixin";
import i18n from "@/i18n";

export default {
    extends: Doughnut,
    mixins: [updateChartMixin],
    props: {
        options: {
            type: Object,
            default: () => null
        },
        rejectedBookings: {
            type: Number,
            required: true
        },
        cancelledBookings: {
            type: Number,
            required: true
        },
        allBookingsCount: {
            type: Number,
            required: true
        }
    },
    computed: {
        data() {
            return {
                datasets: [{
                    label: i18n.t("inputs.rejetedVsCancelledBookingsPieChart.label"),
                    data: [this.rejectedBookings, this.cancelledBookings],
                    backgroundColor: ["#F00", "#F0F"]
                }],
                labels: [i18n.t("inputs.rejetedVsCancelledBookingsPieChart.rejected", {percent: this.rejectedBookings/this.allBookingsCount*100}), i18n.t("inputs.rejetedVsCancelledBookingsPieChart.cancelled", {percent: this.cancelledBookings/this.allBookingsCount*100})]
            }
        }
    },
    mounted() {
        this.renderChart(this.data, this.options);
    }
};